import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Nav, Navbar, Collapse, Button } from 'react-bootstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import messages from '../../locale/messages';
import cx from 'classnames';
import Link from '../Link';
import { adminLogout } from '../../actions/siteadmin/logout';
import { openHeaderModal } from '../../actions/siteadmin/modalActions';
import { connect } from 'react-redux';
import { flowRight as compose } from 'lodash';
import * as FontAwesome from 'react-icons/lib/fa';
import { choseToTheme } from '../../actions/currency/getCurrencyRates';
import history from '../../history'
import { validatePrivilege } from '../../helpers/adminPrivileges';
import { formatLocale } from '../../helpers/formatLocale';

//Images
import DashboardIcon from '../../../public/Icons/dashboard.svg';
import SiteSettingIcon from '../../../public/Icons/site_settings.svg';
import RidersIcon from '../../../public/Icons/manage_riders.svg';
import DriversIcon from '../../../public/Icons/manage_drivers.svg';
import CategoriesIcon from '../../../public/Icons/manage_categories.svg';
import VehiclesIcon from '../../../public/Icons/manage_vehicles.svg';
import BookingsIcon from '../../../public/Icons/manage_bookings.svg';
import PromoCodeIcon from '../../../public/Icons/manage_promo_code.svg';
import CompletedBooking from '../../../public/Icons/completed_bookings.svg';
import ChangePasswordIcon from '../../../public/Icons/changePassword.svg';
import CancalBookingIcon from '../../../public/Icons/cancelled_bookings.svg';
import ManageCurrencyIcon from '../../../public/Icons/manage_currency.svg';
import ManageCancelIcon from '../../../public/Icons/cancelReason.svg';
import RatingIcon from '../../../public/Icons/ratings.svg';
import NotificationIcon from '../../../public/Icons/manage_notifications.svg';
import LogOutIcon from '../../../public/Icons/logout.svg';
import MainSiteIcon from '../../../public/Icons/mainSite.svg';
import HomeSettingIcon from '../../../public/Icons/home_page_settings.svg';
import PayOutManageIcon from '../../../public/Icons/manage_payout.svg';
import PayOutManageFaildIcon from '../../../public/Icons/failed_payout.svg';
import CancelFaildIcon from '../../../public/Icons/cancel_reason.svg';
import staticPageIcon from '../../../public/Icons/manage_static_content.svg';
import ManageLocationIcon from '../../../public/Icons/manage_location.svg';
import RightArrowIcon from '../../../public/Icons/right-arrow.png';
import manageFareIcon from '../../../public/Icons/manage_fare.svg';
import LanguageIcon from '../../../public/Icons/languageIcon.svg';
import scheduleIcon from '../../../public/Icons/schedule_bookings.svg';
import precautionIcon from '../../../public/Icons/precaution_notification.svg';
import trackingIcon from '../../../public/Icons/tracking.svg';
import mobileAppIcon from '../../../public/Icons/mobile_app_settings.svg';
import contentPageIcon from '../../../public/Icons/content_management.svg';
import manualBookingsIcon from '../../../public/Icons/manual_bookings.svg';
import manageAdminIcon from '../../../public/Icons/manage_admins.svg';
import configSettingsIcon from '../../../public/Icons/configSettingsIcon.svg'


import selectedLightIcon from '../../../public/Icons/lightModeOn.svg';
import selectedDarkIcon from '../../../public/Icons/darkModeOn.svg';
import dropDownLightIcon from '../../../public/Icons/lightModeOff.svg';
import dropDownDarkIcon from '../../../public/Icons/adminmobileDark.svg';
import s from './SideMenu.css';
import bt from '../../components/commonStyle.css';

class SideMenu extends React.Component {
  static defaultProps = {
    isSuperAdmin: false,
    privileges: []
  };
  constructor(props) {
    super(props);
    this.state = {
      location: '',
      homepageSettings: false
    }
  }
  componentDidMount() {
    this.setState({
      location: history.location.pathname
    })
  }
  componentDidUpdate(prevProps, prevState) {
    const { location } = this.props;
    if (prevState.location !== location) {
      this.setState({
        location
      })
    }
  }

  render() {
    const { location } = this.state;
    const { adminLogout, isSuperAdmin, privileges, currentLocale, openHeaderModal, selectedTheme, choseToTheme, isOpen, openClose } = this.props;
    let menuActive = selectedTheme === "light" ? s.activeMenu : s.activeMenuDark;
    return (
      <div className={cx(s.sideMenuBg, "sideMenuBgRtl", { [s.menuOpen]: isOpen == 1 }, { ["sideMenuOpenRtl"]: isOpen == 1 })}>
        <div className={cx({ [s.menuClose]: isOpen == 0 }, { ["sideMenuCloseRtl"]: isOpen == 1 }, s.rightMenuClose, s.sideMenuHiddenMd)}>
          <div className={cx(s.closeColor, 'closeColorRTL', 'bgBlack')} onClick={() => openClose()} >
            ×
          </div>
        </div>
        <div className={cx(s.sideMenuList, 'sideMenu', 'sideMenuScroll')}>
          <Navbar expand="lg">
            <Nav className="mr-auto">
              <div onClick={() => { choseToTheme('light') }}>
                <Link to="#" className={cx('d-block d-sm-block d-md-block', "sideNavitemRtl", s.sideNavitem, s.responsiveDasboradMargin, s.sideMenuHiddenMd)} onClick={() => openClose()}>
                  <span className={cx(s.themeIconAlignment, { [s.selectedThemeColor]: selectedTheme === "light" })}>

                    {
                      selectedTheme && selectedTheme === "light" ?
                        <img src={selectedLightIcon} alt='' className={cx(s.themeIcon)} /> :
                        <img src={dropDownLightIcon} alt='' className={cx(s.themeIcon)} />
                    }
                    <FormattedMessage {...messages.lightMode} />
                  </span>
                </Link>
              </div>
              <div onClick={() => { choseToTheme('dark') }}>
                <Link to="#" className={cx('d-block d-sm-block d-md-block ', 'sideNavitemRtl', s.sideNavitem, s.sideMenuHiddenMd)} onClick={() => openClose()}>
                  <span className={cx(s.themeIconAlignment, { [s.selectedThemeColorDark]: selectedTheme === "dark" })}>
                    {
                      selectedTheme && selectedTheme === "dark" ?
                        <img src={selectedDarkIcon} alt='' className={cx(s.themeIcon)} /> :
                        <img src={dropDownDarkIcon} alt='' className={cx(s.themeIcon)} />
                    }
                    <FormattedMessage {...messages.darkMode} />
                  </span>
                </Link>
              </div>
              <Link noLink onClick={(e) => openHeaderModal('languageModal')} className={cx(s.sideNavitem, s.displayTable, s.languageSelector, 'sideNavitemRTL', s.sideMenuHiddenMd)}>
                <span className={cx(s.displayTableCell)}>
                  <img src={LanguageIcon} className={cx(s.sideMenuIcon, s.filterMobile)} />
                </span>
                <span className={cx(s.vtrMiddle, s.displayTableCell)}>
                  {formatLocale(currentLocale)}
                </span>
              </Link>
              <Link to={'/siteadmin'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [menuActive]: location == '/siteadmin' }, { ['sideMenuActive']: location == '/siteadmin' })} onClick={() => openClose()}>
                <span className={cx(s.vtrTop, s.iconWidth, s.displayTableCell)}>
                  <img src={DashboardIcon} className={s.sideMenuIcon} />
                </span>
                <span className={cx(s.vtrMiddle, s.displayTableCell, 'textAlignRightRTL')}>
                  <FormattedMessage {...messages.manageDashboard} />
                </span>
              </Link>
              {
                validatePrivilege(1, privileges) &&
                <Link to={'/siteadmin/settings/site'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { ['sideMenuActive']: location === '/siteadmin/settings/site' }, { [menuActive]: location === '/siteadmin/settings/site' })} onClick={() => openClose()}>
                  <span className={cx(s.vtrTop, s.iconWidth, s.displayTableCell)}>
                    <img src={SiteSettingIcon} className={cx(s.sideMenuIcon, s.noFilter)} />
                  </span>
                  <span className={cx(s.vtrMiddle, s.displayTableCell, 'textAlignRightRTL')}>
                    <FormattedMessage {...messages.siteSettings} />
                  </span>
                </Link>
              }
              {
                validatePrivilege(1, privileges) &&
                <Link to={'/siteadmin/settings/mobile-app'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [menuActive]: location === '/siteadmin/settings/mobile-app' }, { ['sideMenuActive']: location === '/siteadmin/settings/mobile-app' })} onClick={() => openClose()}>
                  <span className={cx(s.vtrTop, s.iconWidth, s.displayTableCell)}>
                    <img src={mobileAppIcon} className={cx(s.sideMenuIcon, s.noFilter)} />
                  </span>
                  <span className={cx(s.vtrMiddle, s.displayTableCell, 'textAlignRightRTL')}>
                    <FormattedMessage {...messages.mobileSettings} />
                  </span>
                </Link>
              }
              {
                validatePrivilege(1, privileges) &&
                <Link to={'/siteadmin/settings/configuration'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [menuActive]: location === '/siteadmin/settings/configuration' })} onClick={() => openClose()}>
                  <span className={cx(s.vtrTop, s.iconWidth, s.displayTableCell)}>
                    <img src={configSettingsIcon} className={cx(s.sideMenuIcon, s.noFilter)} />
                  </span>
                  <span className={cx(s.vtrMiddle, s.displayTableCell, 'textAlignRightRTL')}>
                    <FormattedMessage {...messages.configSettings} />
                  </span>
                </Link>
              }
              {
                validatePrivilege(2, privileges) &&
                <div>
                  <div id='Homepage' className={cx(s.sideNavitem, 'sideNavitemRTL', 'darkBtnHover')}>
                    <Button
                      bsStyle="link"
                      className={cx(s.button, bt.noPadding, s.noBorderBtn, menuActive, s.btnWidth, 'textWhite', 'btnPrimaryDarkMenu')}
                      onClick={() => {
                        this.setState({
                          homepageSettings: !this.state.homepageSettings
                        })
                        // let element = document.getElementById("Homepage")
                        // element.classList.add(menuActive);
                      }
                      }>
                      <span className={cx(s.vtrTop, s.iconWidth)}>
                        <img src={HomeSettingIcon} className={cx(s.sideMenuIcon, s.noFilter)} />
                      </span>
                      <span className={cx(s.vtrMiddle, 'textAlignRightRTL')}>
                        <FormattedMessage {...messages.HomeSiteSettings} />
                      </span>
                      {
                        this.state.homepageSettings &&
                        <span>
                          <FontAwesome.FaAngleUp className={s.navigationIcon} />
                        </span>
                      }

                      {
                        !this.state.homepageSettings && <span><FontAwesome.FaAngleDown className={s.navigationIcon} /></span>
                      }
                    </Button>
                  </div>
                  <Collapse in={this.state.homepageSettings}>
                    <div>
                      <Link to={'/siteadmin/homepage/banner'} className={cx(s.sideNavitem, s.displayTable, s.sideNavitemCollapsePadding, 'sideNavitemRTL', { [menuActive]: location.startsWith('/siteadmin/homepage-homesettings') })} onClick={() => openClose()}>
                        <span className={cx(s.vtrTop, s.iconWidth, s.displayTableCell, s.sideNavitemCollapse, 'rightArrowRTL')}>
                          <img src={RightArrowIcon} className={cx(s.sideNavitemCollapseIcon)} />
                        </span>
                        <span className={cx(s.vtrMiddle, s.sideNavitemCollapseText, s.displayTableCell, 'textAlignRightRTL')}>
                          <FormattedMessage {...messages.homeSectionSettings} />
                        </span>
                      </Link>
                      <Link to={'/siteadmin/homepage/category'} className={cx(s.sideNavitem, s.displayTable, s.sideNavitemCollapsePadding, 'sideNavitemRTL', { [menuActive]: location.startsWith('/siteadmin/homepage-citysettings') })} onClick={() => openClose()}>
                        <span className={cx(s.vtrTop, s.iconWidth, s.displayTableCell, s.sideNavitemCollapse, 'rightArrowRTL')}>
                          <img src={RightArrowIcon} className={cx(s.sideNavitemCollapseIcon)} />
                        </span>
                        <span className={cx(s.vtrMiddle, s.sideNavitemCollapseText, s.displayTableCell, 'textAlignRightRTL')}>
                          <FormattedMessage {...messages.citySectionSettings} />
                        </span>
                      </Link>
                      <Link to={'/siteadmin/homepage/topfeature'} className={cx(s.sideNavitem, s.displayTable, s.sideNavitemCollapsePadding, 'sideNavitemRTL', { [menuActive]: location.startsWith('/siteadmin/homepage-aboutsettings') })} onClick={() => openClose()}>
                        <span className={cx(s.vtrTop, s.iconWidth, s.displayTableCell, s.sideNavitemCollapse, 'rightArrowRTL')}>
                          <img src={RightArrowIcon} className={cx(s.sideNavitemCollapseIcon)} />
                        </span>
                        <span className={cx(s.vtrMiddle, s.sideNavitemCollapseText, s.displayTableCell, 'textAlignRightRTL')}>
                          <FormattedMessage {...messages.aboutSectionSettings} />
                        </span>
                      </Link>
                      <Link to={'/siteadmin/homepage/rider'} className={cx(s.sideNavitem, s.displayTable, s.sideNavitemCollapsePadding, 'sideNavitemRTL', { [menuActive]: location.startsWith('/siteadmin/homepage-safetysettings') })} onClick={() => openClose()}>
                        <span className={cx(s.vtrTop, s.iconWidth, s.displayTableCell, s.sideNavitemCollapse, 'rightArrowRTL')}>
                          <img src={RightArrowIcon} className={cx(s.sideNavitemCollapseIcon)} />
                        </span>
                        <span className={cx(s.vtrMiddle, s.sideNavitemCollapseText, s.displayTableCell, 'textAlignRightRTL')}>
                          <FormattedMessage {...messages.safetySectionSettings} />
                        </span>
                      </Link>
                      <Link to={'/siteadmin/homepage/driver'} className={cx(s.sideNavitem, s.displayTable, s.sideNavitemCollapsePadding, 'sideNavitemRTL', { [menuActive]: location.startsWith('/siteadmin/homepage-signupsettings') })} onClick={() => openClose()}>
                        <span className={cx(s.vtrTop, s.iconWidth, s.displayTableCell, s.sideNavitemCollapse, 'rightArrowRTL')}>
                          <img src={RightArrowIcon} className={cx(s.sideNavitemCollapseIcon)} />
                        </span>
                        <span className={cx(s.vtrMiddle, s.sideNavitemCollapseText, s.displayTableCell, 'textAlignRightRTL')}>
                          <FormattedMessage {...messages.signupSectionSettings} />
                        </span>
                      </Link>
                      <Link to={'/siteadmin/homepage/footer'} className={cx(s.sideNavitem, s.displayTable, s.sideNavitemCollapsePadding, 'sideNavitemRTL', { [menuActive]: location.startsWith('/siteadmin/homepage-footersettings') })} onClick={() => openClose()}>
                        <span className={cx(s.vtrTop, s.iconWidth, s.displayTableCell, s.sideNavitemCollapse, 'rightArrowRTL')}>
                          <img src={RightArrowIcon} className={cx(s.sideNavitemCollapseIcon)} />
                        </span>
                        <span className={cx(s.vtrMiddle, s.sideNavitemCollapseText, s.displayTableCell, 'textAlignRightRTL')}>
                          <FormattedMessage {...messages.footerSectionSettings} />
                        </span>
                      </Link>
                    </div>
                  </Collapse>
                </div>
              }
              {isSuperAdmin && <div>
                <div id='Homepage' className={cx(s.sideNavitem, 'sideNavitemRTL', 'darkBtnHover')}>
                  <Button
                    bsStyle="link"
                    className={cx(s.button, bt.noPadding, s.noBorderBtn, menuActive, s.btnWidth, 'textWhite', 'btnPrimaryDarkMenu')}
                    onClick={() => {
                      this.setState({
                        subAdmin: !this.state.subAdmin
                      })
                      // let element = document.getElementById("Homepage")
                      // element.classList.add(menuActive);
                    }
                    }>
                    <span className={cx(s.vtrTop, s.iconWidth, s.iconWidth)}>
                      <img src={manageAdminIcon} className={cx(s.sideMenuIcon, s.noFilter)} />
                    </span>
                    <span className={cx(s.vtrMiddle, 'textAlignRightRTL')}>
                      <FormattedMessage {...messages.manageAdmin} />
                    </span>
                    {
                      this.state.subAdmin &&
                      <span>
                        <FontAwesome.FaAngleUp className={s.navigationIcon} />
                      </span>
                    }

                    {
                      !this.state.subAdmin && <span><FontAwesome.FaAngleDown className={s.navigationIcon} /></span>
                    }
                  </Button>
                </div>
                <Collapse in={this.state.subAdmin} className={s.subMenu}>
                  <div>
                    <Link to={'/siteadmin/admin-users'} className={cx(s.sideNavitem, s.displayTable, s.sideNavitemCollapsePadding, 'sideNavitemRTL', { [menuActive]: location.startsWith('/siteadmin/admin-users') })} onClick={() => openClose()}>
                      <span className={cx(s.vtrTop, s.iconWidth, s.displayTableCell, s.sideNavitemCollapse, 'rightArrowRTL')}>
                        <img src={RightArrowIcon} className={cx(s.sideNavitemCollapseIcon)} />
                      </span>
                      <span className={cx(s.vtrMiddle, s.sideNavitemCollapseText, s.displayTableCell, 'textAlignRightRTL')}>
                        <FormattedMessage {...messages.manageAdminUsers} />
                      </span>
                    </Link>

                    <Link to={'/siteadmin/admin-roles'} className={cx(s.sideNavitem, s.displayTable, s.sideNavitemCollapsePadding, 'sideNavitemRTL', { [menuActive]: location.startsWith('/siteadmin/admin-roles') })} onClick={() => openClose()}>
                      <span className={cx(s.vtrTop, s.iconWidth, s.displayTableCell, s.sideNavitemCollapse, 'rightArrowRTL')}>
                        <img src={RightArrowIcon} className={cx(s.sideNavitemCollapseIcon)} />
                      </span>
                      <span className={cx(s.vtrMiddle, s.sideNavitemCollapseText, s.displayTableCell, 'textAlignRightRTL')}>
                        <FormattedMessage {...messages.manageAdminRoles} />
                      </span>
                    </Link>
                  </div>
                </Collapse>
              </div>
              }
              {
                validatePrivilege(3, privileges) &&
                <Link to={'/siteadmin/riders'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', 'menuIconRTL', { [menuActive]: location.startsWith('/siteadmin/riders') })} onClick={() => openClose()}>
                  <span className={cx(s.vtrTop, s.iconWidth, s.displayTableCell)}>
                    <img src={RidersIcon} className={s.sideMenuIcon} />
                  </span>
                  <span className={cx(s.vtrMiddle, s.displayTableCell, 'textAlignRightRTL')}>
                    <FormattedMessage {...messages.ridersMenu} />
                  </span>
                </Link>}
              {
                validatePrivilege(4, privileges) &&
                <Link to={'/siteadmin/drivers'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', 'menuIconRTL', { [menuActive]: location.startsWith('/siteadmin/drivers') })} onClick={() => openClose()}>
                  <span className={cx(s.vtrTop, s.iconWidth, s.displayTableCell)}>
                    <img src={DriversIcon} className={s.sideMenuIcon} />
                  </span>
                  <span className={cx(s.vtrMiddle, s.displayTableCell, 'textAlignRightRTL')}>
                    <FormattedMessage {...messages.driverMenu} />
                  </span>
                </Link>}
              {validatePrivilege(5, privileges) && <Link to={'/siteadmin/vehicles'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [menuActive]: location.startsWith('/siteadmin/vehicles') })} onClick={() => openClose()}>
                <span className={cx(s.vtrTop, s.iconWidth, s.displayTableCell)}>
                  <img src={VehiclesIcon} className={s.sideMenuIcon} />
                </span>
                <span className={cx(s.vtrMiddle, s.displayTableCell, 'textAlignRightRTL')}>
                  <FormattedMessage {...messages.vehiclesMenu} />
                </span>
              </Link>}
              {
                validatePrivilege(6, privileges) &&
                <Link to={'/siteadmin/category'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [menuActive]: location.startsWith('/siteadmin/category') })} onClick={() => openClose()}>
                  <span className={cx(s.vtrTop, s.iconWidth, s.displayTableCell)}>
                    <img src={CategoriesIcon} className={s.sideMenuIcon} />
                  </span>
                  <span className={cx(s.vtrMiddle, s.displayTableCell, 'textAlignRightRTL')}>
                    <FormattedMessage {...messages.categoryMenu} />
                  </span>
                </Link>}
              {
                validatePrivilege(18, privileges) &&
                <Link to={'/siteadmin/payment-gateway'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [menuActive]: location.startsWith('/siteadmin/payment-gateway') })} onClick={() => openClose()}>
                  <span className={cx(s.vtrTop, s.iconWidth, s.displayTableCell)}>
                    <img src={CategoriesIcon} className={s.sideMenuIcon} />
                  </span>
                  <span className={cx(s.vtrMiddle, s.displayTableCell, 'textAlignRightRTL')}>
                    <FormattedMessage {...messages.managePaymentGateWay} />
                  </span>
                </Link>}
              {
                validatePrivilege(7, privileges) &&
                <Link to={'/siteadmin/location'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [menuActive]: (location.startsWith('/siteadmin/location') || location.startsWith('/siteadmin/edit-location')) })} onClick={() => openClose()}>
                  <span className={cx(s.vtrTop, s.iconWidth, s.displayTableCell)}>
                    <img src={ManageLocationIcon} className={cx(s.sideMenuIcon, s.noFilter)} />
                  </span>
                  <span className={cx(s.vtrMiddle, s.displayTableCell, 'textAlignRightRTL')}>
                    <FormattedMessage {...messages.location} />
                  </span>
                </Link>}
              {
                validatePrivilege(8, privileges) &&
                <Link to={'/siteadmin/pricing/list'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [menuActive]: location.startsWith('/siteadmin/pricing') })} onClick={() => openClose()}>
                  <span className={cx(s.vtrTop, s.iconWidth, s.displayTableCell)}>
                    <img src={manageFareIcon} className={cx(s.sideMenuIcon, s.noFilter)} />
                  </span>
                  <span className={cx(s.vtrMiddle, s.displayTableCell, 'textAlignRightRTL')}>
                    <FormattedMessage {...messages.manageFare} />
                  </span>
                </Link>}
              {
                validatePrivilege(17, privileges) &&
                <Link to={'/siteadmin/manual-bookings'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [menuActive]: location.startsWith('/siteadmin/manual-bookings') })} onClick={() => openClose()}>
                  <span className={cx(s.vtrTop, s.iconWidth, s.displayTableCell)}>
                    <img src={manualBookingsIcon} className={cx(s.sideMenuIcon, s.noFilter)} />
                  </span>
                  <span className={cx(s.vtrMiddle, s.displayTableCell, 'textAlignRightRTL')}>
                    <FormattedMessage {...messages.manualBookings} />
                  </span>
                </Link>
              }
              {
                validatePrivilege(9, privileges) &&
                <Link to={'/siteadmin/schedule-bookings'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [menuActive]: location.startsWith('/siteadmin/schedule-bookings') })} onClick={() => openClose()}>
                  <span className={cx(s.vtrTop, s.iconWidth, s.displayTableCell)}>
                    <img src={scheduleIcon} />
                  </span>
                  <span className={cx(s.vtrMiddle, s.displayTableCell, 'textAlignRightRTL')}>
                    <FormattedMessage {...messages.scheduleBooking} />
                  </span>
                </Link>
              }
              {
                validatePrivilege(9, privileges) &&
                <Link to={'/siteadmin/bookings'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [menuActive]: location.startsWith('/siteadmin/bookings') })} onClick={() => openClose()}>
                  <span className={cx(s.vtrTop, s.iconWidth, s.displayTableCell)}>
                    <img src={BookingsIcon} className={s.sideMenuIcon} />
                  </span>
                  <span className={cx(s.vtrMiddle, s.displayTableCell, 'textAlignRightRTL')}>
                    <FormattedMessage {...messages.bookingsMenu} />
                  </span>
                </Link>
              }
              {
                validatePrivilege(9, privileges) &&
                <Link to={'/siteadmin/completed-bookings'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [menuActive]: location.startsWith('/siteadmin/completed-bookings') })} onClick={() => openClose()}>
                  <span className={cx(s.vtrTop, s.iconWidth, s.displayTableCell)}>
                    <img src={CompletedBooking} className={cx(s.sideMenuIcon, s.noFilter)} />
                  </span>
                  <span className={cx(s.vtrMiddle, s.displayTableCell, 'textAlignRightRTL')}>
                    <FormattedMessage {...messages.manageCompletedTrips} />
                  </span>
                </Link>}
              {
                validatePrivilege(9, privileges) &&
                <Link to={'/siteadmin/cancelled-bookings'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [menuActive]: location.startsWith('/siteadmin/cancelled-bookings') })} onClick={() => openClose()}>
                  <span className={cx(s.vtrTop, s.iconWidth, s.displayTableCell)}>
                    <img src={CancalBookingIcon} className={cx(s.sideMenuIcon, s.noFilter)} />
                  </span>
                  <span className={cx(s.vtrMiddle, s.displayTableCell, 'textAlignRightRTL')}>
                    <FormattedMessage {...messages.manageCancelledTrips} />
                  </span>
                </Link>}

              {
                validatePrivilege(19, privileges) && <Link to={'/siteadmin/tracking'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [menuActive]: location == '/siteadmin/tracking' })} onClick={() => openClose()}>
                  <span className={cx(s.vtrTop, s.iconWidth, s.displayTableCell)}>
                    <img src={trackingIcon} className={cx(s.sideMenuIcon, s.noFilter)} />
                  </span>
                  <span className={cx(s.vtrMiddle, s.displayTableCell, 'textAlignRightRTL')}>
                    <FormattedMessage {...messages.tracking} />
                  </span>
                </Link>}

              {
                validatePrivilege(10, privileges) &&
                <Link to={'/siteadmin/ratings'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [menuActive]: location == '/siteadmin/ratings' })} onClick={() => openClose()}>
                  <span className={cx(s.vtrTop, s.iconWidth, s.displayTableCell)}>
                    <img src={RatingIcon} className={cx(s.sideMenuIcon, s.noFilter)} />
                  </span>
                  <span className={cx(s.vtrMiddle, s.displayTableCell, 'textAlignRightRTL')}>
                    <FormattedMessage {...messages.ratings} />
                  </span>
                </Link>}
              {
                validatePrivilege(11, privileges) &&
                <Link to={'/siteadmin/promo-code/list'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [menuActive]: location.startsWith('/siteadmin/promo-code') })} onClick={() => openClose()}>
                  <span className={cx(s.vtrTop, s.iconWidth, s.displayTableCell)}>
                    <img src={PromoCodeIcon} className={s.sideMenuIcon} />
                  </span>
                  <span className={cx(s.vtrMiddle, s.displayTableCell, 'textAlignRightRTL')}>
                    <FormattedMessage {...messages.managePromoCode} />
                  </span>
                </Link>}
              <Link to={'/siteadmin/change/admin'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [menuActive]: location == '/siteadmin/change/admin' })} onClick={() => openClose()}>
                <span className={cx(s.vtrTop, s.iconWidth, s.displayTableCell)}>
                  <img src={ChangePasswordIcon} className={cx(s.sideMenuIcon, s.noFilter)} />
                </span>
                <span className={cx(s.vtrMiddle, s.displayTableCell, 'textAlignRightRTL')}>
                  <FormattedMessage {...messages.changePassword} />
                </span>
              </Link>
              {
                validatePrivilege(12, privileges) &&
                <Link to={'/siteadmin/notifications'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [menuActive]: location == '/siteadmin/notifications' })} onClick={() => openClose()}>
                  <span className={cx(s.vtrTop, s.iconWidth, s.displayTableCell)}>
                    <img src={NotificationIcon} className={cx(s.sideMenuIcon, s.noFilter)} />
                  </span>
                  <span className={cx(s.vtrMiddle, s.displayTableCell, 'textAlignRightRTL')}>
                    <FormattedMessage {...messages.manageNotifications} />
                  </span>
                </Link>}
              {validatePrivilege(20, privileges) && <Link to={'/siteadmin/currency'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [menuActive]: location == '/siteadmin/currency' })} onClick={() => openClose()}>
                <span className={cx(s.vtrTop, s.iconWidth, s.displayTableCell)}>
                  <img src={ManageCurrencyIcon} className={cx(s.sideMenuIcon, s.noFilter)} />
                </span>
                <span className={cx(s.vtrMiddle, s.displayTableCell, 'textAlignRightRTL')}>
                  <FormattedMessage {...messages.manageCurrency} />
                </span>
              </Link>}
              {
                validatePrivilege(13, privileges) &&
                <Link to={'/siteadmin/cancel-reasons'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [menuActive]: location.startsWith('/siteadmin/cancel-reasons') })} onClick={() => openClose()}>
                  <span className={cx(s.vtrTop, s.iconWidth, s.displayTableCell)}>
                    <img src={CancelFaildIcon} className={cx(s.sideMenuIcon, s.noFilter)} />
                  </span>
                  <span className={cx(s.vtrMiddle, s.displayTableCell, 'textAlignRightRTL')}>
                    <FormattedMessage {...messages.manageCancelReason} />
                  </span>
                </Link>}
              {
                validatePrivilege(14, privileges) &&
                <Link to={'/siteadmin/payout'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [menuActive]: location.startsWith('/siteadmin/payout') })} onClick={() => openClose()}>
                  <span className={cx(s.vtrTop, s.iconWidth, s.displayTableCell)}>
                    <img src={PayOutManageIcon} className={cx(s.sideMenuIcon, s.noFilter)} />
                  </span>
                  <span className={cx(s.vtrMiddle, s.displayTableCell, 'textAlignRightRTL')}>
                    <FormattedMessage {...messages.managePayout} />
                  </span>
                </Link>}
              {
                validatePrivilege(14, privileges) &&
                <Link to={'/siteadmin/failed-payout'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [menuActive]: location.startsWith('/siteadmin/failed-payout') })} onClick={() => openClose()}>
                  <span className={cx(s.vtrTop, s.iconWidth, s.displayTableCell)}>
                    <img src={PayOutManageFaildIcon} className={cx(s.sideMenuIcon, s.noFilter)} />
                  </span>
                  <span className={cx(s.vtrMiddle, s.displayTableCell, 'textAlignRightRTL')}>
                    <FormattedMessage {...messages.manageFailedPayout} />
                  </span>
                </Link>}
              {
                validatePrivilege(15, privileges) &&
                <Link to={'/siteadmin/staticpage/manage'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [menuActive]: location.startsWith('/siteadmin/staticpage/') })} onClick={() => openClose()}>
                  <span className={cx(s.vtrTop, s.iconWidth, s.displayTableCell)}>
                    <img src={staticPageIcon} className={cx(s.sideMenuIcon, s.noFilter)} />
                  </span>
                  <span className={cx(s.vtrMiddle, s.displayTableCell, 'textAlignRightRTL')}>
                    <FormattedMessage {...messages.staticpageManagement} />
                  </span>
                </Link>}
              {
                validatePrivilege(15, privileges) &&
                <Link to={'/siteadmin/contentpage/manage'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [menuActive]: location.startsWith('/siteadmin/contentpage/') })} onClick={() => openClose()}>
                  <span className={cx(s.vtrTop, s.iconWidth, s.displayTableCell)}>
                    <img src={contentPageIcon} className={cx(s.sideMenuIcon, s.noFilter)} />
                  </span>
                  <span className={cx(s.vtrMiddle, s.displayTableCell, 'textAlignRightRTL')}>
                    <FormattedMessage {...messages.contentpageManagement} />
                  </span>
                </Link>}
              {
                validatePrivilege(16, privileges) &&
                <Link to={'/siteadmin/precaution-notification'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [menuActive]: location == '/siteadmin/precaution-notification' })} onClick={() => openClose()}>
                  <span className={cx(s.vtrTop, s.iconWidth, s.displayTableCell)}>
                    <img src={precautionIcon} className={cx(s.sideMenuIcon, s.noFilter)} />
                  </span>
                  <span className={cx(s.vtrMiddle, s.displayTableCell, 'textAlignRightRTL')}>
                    <FormattedMessage {...messages.precautionNotification} />
                  </span>
                </Link>}
              <Link to={'/'} className={cx(s.sideNavitem, 'sideNavitemRTL', s.displayTable, s.hiddenLg)} onClick={() => openClose()}>
                <span className={cx(s.vtrTop, s.iconWidth, s.displayTableCell)}>
                  <img src={MainSiteIcon} className={cx(s.sideMenuIcon, s.filterMobile)} />
                </span>
                <span className={cx(s.vtrMiddle, s.displayTableCell, 'textAlignRightRTL')}>
                  <FormattedMessage {...messages.goToMainSite} />
                </span>
              </Link>
              <Link to={''} onClick={() => adminLogout()} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', s.paddingBottomextra, s.hiddenLg)}>
                <span className={cx(s.vtrTop, s.iconWidth, s.displayTableCell)}>
                  <img src={LogOutIcon} className={cx(s.sideMenuIcon, s.filterMobile)} />
                </span>
                <span className={cx(s.vtrMiddle, s.displayTableCell, 'textAlignRightRTL')}>
                  <FormattedMessage {...messages.logout} />
                </span>
              </Link>
            </Nav>
          </Navbar>
        </div>
      </div>
    );
  }
}
const mapState = state => ({
  isSuperAdmin: state.runtime.isSuperAdmin,
  privileges: state.adminPrevileges.privileges && state.adminPrevileges.privileges.privileges,
  currentLocale: state.intl.locale,
  selectedTheme: state.currency.theme
});
const mapDispatch = {
  adminLogout,
  openHeaderModal,
  choseToTheme
};
export default compose(injectIntl,
  withStyles(s, bt),
  (connect(mapState, mapDispatch))
)(SideMenu);